import {
  Dialog,
  DialogTitle,
  DialogContent,
  Typography,
  Button,
  DialogActions,
} from "@mui/material";
// hooks
import useResponsive from '../../hooks/useResponsive';


export default function CannotApplyAverageSalaryDialog({ isOpen, close }) {
  const smUp = useResponsive('up', 'sm');

  return (
    <Dialog open={isOpen} onClose={close} maxWidth="xs">
      <DialogTitle variant="h6" sx={{ px: { xs: 3, sm: 4 }, pb: 2 }}>
        작성한 업무 가능한 시간은 <br/>평균 인건비를 적용할 수 없어요.
      </DialogTitle>
      <DialogContent sx={{ pl: { xs: 3, sm: 4 }, pr: {xs: 6, sm: 8} }}>
        <Typography variant="body2">
          테이블을 참고해 인건비를 직접 입력해주세요.
        </Typography>
      </DialogContent>
      <DialogActions>
        <Button variant="contained" fullWidth={!smUp} size="large" sx={{ px: 3 }} onClick={close} >
          확인했어요
        </Button>
      </DialogActions>
    </Dialog>
  )
}